import React, { Component } from 'react';
import { connect } from 'react-redux';
import config from 'config/api';
import Paragrapher from 'components/UI/Paragrapher/Paragrapher';
import Header from 'components/Header/Header';
import Footer from 'components/Footer';
import ScrollToTopOnMount from 'components/UI/ScrollToTopOnMount';
import BlockTitle from 'components/UI/BlockTitle';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { withStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import i18n from 'helpers/i18n';
import Banner from 'components/Banner/Banner';
import Spinner from 'components/UI/Spinner';
import Template from 'components/Template/Template';
import Fade from '@material-ui/core/Fade';
import { fetchData, getDataLegal, getLoadingError } from '../../ducks/asyncFetcher';

const styles = (theme) => {
  return {
    root: {
      minHeight: '100%',
      // display: "flex",
      // flexDirection: "column",
      // "& > *": {
      //   flex: 1,
      // },
    },
    paper: {
      padding: theme.spacing(4),
    },
    paperWrapper: {
      width: '100%'
    },
  };
};

const AF_KEY = 'legal';

class Legal extends Component {
  componentDidMount() {
    this.props.onMount();
  }
  render() {
    const { $$data: $$legal, classes, onPanelToggle, userRole } = this.props;

    return (
      <Template headerImage="background" maxHeight="auto">
        <Fade in timeout={1000}>
          <Box className={classes.paperWrapper}>
            <Paper square elevation={0} className={classes.paper}>
              <Choose>
                <When condition={$$legal !== undefined}>
                  <Typography variant="h2" gutterBottom>{$$legal.get('title')}</Typography>

                  <Paragrapher prettyfy={true} text={$$legal.get('content')} transformBullets={false} />
                </When>
                <Otherwise>
                  <Spinner style={{ marginTop: 200 }}>Chargement...</Spinner>
                </Otherwise>
              </Choose>
            </Paper>
          </Box>
        </Fade>
      </Template>
    );
  }
}

function mapStateToProps(state) {
  const props = {
    $$data: getDataLegal(state),
    error: getLoadingError(state),
  };
  return props;
}
function mapDispatchToProps(dispatch) {
  return {
    onMount: () => {
      dispatch(fetchData({ key: AF_KEY, fetchUrl: config.legal }));
    },
  };
}
export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(Legal));



// WEBPACK FOOTER //
// ./src/components/Legal/Legal.jsx